<template>
  <BaseModal
    :value="true"
    @input="$emit('close')"
    title="Update Quantity Required"
  >
    <div class="bulk-quantity-modal-content">
      <p class="mb-4">
        Update quantity required for <strong>{{ count }}</strong> selected
        application(s)
      </p>
      <div class="form-group">
        <label>Quantity Required</label>
        <input
          v-model.number="quantity"
          type="number"
          min="0"
          class="regular full bordered"
          placeholder="Enter quantity..."
        />
      </div>
      <div class="modal-actions">
        <button @click="save" class="btn-success-button">
          Update {{ count }} Applications
        </button>
        <button @click="$emit('close')" class="btn-dark-button">Cancel</button>
      </div>
    </div>
  </BaseModal>
</template>

<script>
export default {
  name: "BulkQuantityModal",
  props: {
    count: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      quantity: 1
    };
  },
  methods: {
    save() {
      if (this.quantity < 0) {
        this.$toast.error("Quantity must be positive");
        return;
      }
      this.$emit("save", this.quantity);
    }
  }
};
</script>

<style lang="scss" scoped>
.bulk-quantity-modal-content {
  padding: 1rem;
}

.form-group {
  margin-bottom: 1rem;

  label {
    display: block;
    font-weight: 600;
    margin-bottom: 0.5rem;
  }
}

.modal-actions {
  display: flex;
  gap: 0.5rem;
  justify-content: flex-end;
  margin-top: 1rem;
}
</style>
